import { RequestError } from '@/services/config';

/**
 * The error the API client rejects with. Re-exported so screens can tell a status code apart
 * (`RequestError.isRequestError(error) && error.status === 404`) without reaching into the
 * generated client.
 */
export { RequestError };

/** What a domain query or mutation can fail with. */
export type ApiError = RequestError | Error;

/** The HTTP status of a failed API call, or undefined for a network or non-API error. */
export function apiErrorStatus(error: unknown): number | undefined {
    return RequestError.isRequestError(error) ? error.status : undefined;
}

/**
 * Whether a failed request means the thing is not there for this user: a 404, or a 403 for an
 * id the user may not open. The two are shown alike, so a page does not reveal which ids exist.
 */
export function isNotFoundError(error: unknown): boolean {
    const status = apiErrorStatus(error);
    return status === 403 || status === 404;
}
